import { render, staticRenderFns } from "./ManageOrder.vue?vue&type=template&id=5a27e3ec&scoped=true"
import script from "./ManageOrder.vue?vue&type=script&lang=js"
export * from "./ManageOrder.vue?vue&type=script&lang=js"
import style0 from "./ManageOrder.vue?vue&type=style&index=0&id=5a27e3ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a27e3ec",
  null
  
)

export default component.exports